import { Tabs, Text } from "@mantine/core";
import CustomBadge from "../CustomBadge/CustomBadge";

const CustomTabs = ({
  tabs = [],
  tabCounts = {},
  listProps = {},
  tabProps = {},
  grow = false,
  textSize = "sm",
  ...props
}) => {
  return (
    <Tabs {...props}>
      <Tabs.List grow={grow} {...listProps}>
        {tabs.map((tab) => (
          <Tabs.Tab key={tab.value} value={tab.value} {...tabProps}>
            <span className="inline-flex items-center gap-2">
              {tab.icon && (
                <span className="hidden md:inline-flex">{tab.icon}</span>
              )}
              <Text size={textSize}>{tab.label}</Text>
              {tabCounts[tab.value] !== undefined && (
                <span className="hidden md:inline-flex">
                  <CustomBadge>{tabCounts[tab.value]}</CustomBadge>
                </span>
              )}
            </span>
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  );
};

export default CustomTabs;
